import i18next from 'i18next'
import {FC, useMemo} from 'react'
import {Col, Form, Row} from 'react-bootstrap'
import CurrencyInput from 'react-currency-input-field'
import {useTranslation} from 'react-i18next'
import {useAppDispatch, useAppSelector} from 'src/redux/hooks'
import {setSoItem, soSelector} from 'src/redux/slices/soSlices'

interface Props {}

export const InputShippingTolerance: FC<Props> = () => {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const {orderItem, soItem} = useAppSelector(soSelector)

  const defaultValue = useMemo(() => orderItem?.shipping_tolerance ?? '0', [orderItem])

  const handleChange = (value: string) => {
    dispatch(setSoItem({...soItem, shipping_tolerance: Number(value)}))
  }

  return (
    <Row className='mb-3'>
      <Col md={4}>
        <Form.Label className='mt-3'>{t('CREATE_SO.ADD_SO_MODAL.SHIPPING_TOLERANCE')}</Form.Label>
      </Col>
      <Col md={8}>
        <CurrencyInput
          className='form-control form-control-sm'
          id='kuantum'
          placeholder={t('CREATE_SO.ADD_SO_MODAL.SHIPPING_TOLERANCE')}
          defaultValue={defaultValue}
          decimalSeparator={i18next.language === 'en' ? '.' : ','}
          groupSeparator={i18next.language === 'en' ? ',' : '.'}
          decimalsLimit={3}
          onValueChange={(value: any) => handleChange(value as string)}
        />
      </Col>
    </Row>
  )
}
